import { useAuth0 } from "@auth0/auth0-react";
import styles from "./incomeCategoryFilter.module.css";
import { Plus, Search } from "react-feather";
import { Link } from "react-router-dom";

const IncomeCategoryFilter = ({ setFilterData, setAddModalOpen, setPage }) => {
  const { user, isAuthenticated } = useAuth0();

  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input type="text" placeholder="Search" onChange={(e) => { setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; }); setPage(0); }} />
      </div>
    </div>
    <div className={`${styles.FilterSec}`}>
      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("income-category:create") > -1 && <Link className={`${styles.AddNoteBu}`} onClick={(e) => setAddModalOpen(true)}>
        <Plus /> <span>Category</span>
      </Link>}
    </div>
  </div>);
};

export default IncomeCategoryFilter;